import { t as r } from "./to-primitive.js";
import { i as t } from "./is-symbol.js";
var o = function o(_o) {
  var i = r(_o, "string");
  return t(i) ? i : i + "";
};
export { o as t };